import { RootState, useAppSelector } from 'cache/store';
import { VERSION } from 'config/app.config';
import { DEVICE_INFO } from 'constants/common';
import { FormValuesLogin, LoginPayload } from 'models/authModel';
import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { decode } from 'utils/base64';
import { getDeviceInfo } from 'utils/function';
import styles from './login-header.style';

interface Props {
    onLogin: (payload: LoginPayload, showAlertSuccess: boolean, closeModal: boolean, rememberAccount?: boolean) => void;
    onShowAuth: () => void;
    onShowForgotPW: () => void;
}

function LoginHeader(props: Props) {
    const { onLogin, onShowAuth, onShowForgotPW } = props;
    const { rememberData, isLogged } = useAppSelector((state: RootState) => state.auth);

    const [rememberAccount, setRememberAccount] = useState(false);

    const { handleSubmit, register, setFocus, setValue } = useForm<FormValuesLogin>();

    useEffect(() => {
        if (rememberData?.isRemember && rememberData?.account && !isLogged) {
            setValue('username', decode(rememberData.account).split('|')[0]);
            setValue('password', decode(rememberData.account).split('|')[1]);
            setRememberAccount(true);
        }
    }, [rememberData, isLogged, setValue]);

    const handleLoginForm: SubmitHandler<FormValuesLogin> = async (values) => {
        const { username, password } = values;
        if (!username.toLowerCase().trim()) {
            setFocus('username');
            toast.error('Vui lòng nhập tài khoản !');
            return;
        }
        if (!password) {
            setFocus('password');
            toast.error('Vui lòng nhập mật khẩu!');
            return;
        }

        let deviceInfo = DEVICE_INFO;
        if (!deviceInfo.uuid) {
            deviceInfo = await getDeviceInfo();
        }

        const payload = {
            username,
            password,
            version: VERSION,
            di: deviceInfo,
        };
        onLogin(payload, true, false, rememberAccount);
    };

    return (
        <form className={styles.right} onSubmit={handleSubmit(handleLoginForm)}>
            <div className={styles.formLogin}>
                <div className={styles.inputAccount}>
                    <div className={styles.inputWrap}>
                        <img className={styles.icon} src={require('assets/images/icons/user_input.png')} alt="" />
                        <input {...register('username')} className={styles.input} type="text" placeholder="Tên Đăng Nhập" />
                    </div>
                    <div className={styles.remember}>
                        <input onChange={(e) => setRememberAccount(e.target.checked)} checked={rememberAccount} id="remember" type="checkbox" />
                        <label htmlFor="remember">Nhớ mật khẩu</label>
                    </div>
                </div>

                <div className={styles.inputAccount}>
                    <div className={styles.inputWrap}>
                        <img className={styles.icon} src={require('assets/images/icons/pw_input.png')} alt="" />
                        <input {...register('password')} className={styles.input} type={'password'} placeholder="Mật khẩu" />
                    </div>
                </div>
                <div className={styles.inputAccount}>
                    <button type="button" className={styles.forgetPw} onClick={onShowForgotPW}>
                        Quên mật khẩu
                    </button>
                </div>
            </div>
            <div className={styles.btnGroup}>
                <button type="button" className={styles.buttonLogin} onClick={handleSubmit(handleLoginForm)}>
                    Đăng nhập
                </button>
                <button type="button" className={styles.buttonRegister} onClick={onShowAuth}>
                    Đăng ký
                </button>
            </div>
        </form>
    );
}

export default LoginHeader;
